import {useLocation} from "react-router-dom";
import qs from 'query-string';
import {useMemo} from "react";

export const useQueryParams = () => {
  const { search } = useLocation();
  return useMemo(() => qs.parse(search), [search]);
}